<template>
  <b-modal v-model="show" hide-footer hide-header centered no-close-on-backdrop>
    <b-overlay :show="isLoading" spinner-variant="primary">
      <h3><b-icon-chat-left-dots-fill /> Надіслати СМС повідомлення</h3>
      <div class="form-input mb-4 pt-3">
        <label for="">Отримувач</label>
        <b-form-input v-model="user.phone" disabled />
        <p>
          <small v-if="user.last_name">
            {{ user.last_name }}
          </small>
          <small v-if="user.first_name">
            {{ user.first_name }}
          </small>
        </p>
      </div>
      <b-form-textarea
        placeholder="Текст повідомлення"
        class="mb-2"
        v-model="message"
      >
      </b-form-textarea>
      <b-alert variant="warning" class="py-1 px-2" show>
        Рекомендовано використовувати латинські літери
      </b-alert>
      <div class="mt-4">
        <b-button
          @click="sendSms"
          variant="primary"
          class="w-100 mb-2"
          size="lg"
        >
          Надіслати
        </b-button>
        <b-button
          @click="show = false"
          variant="outline-danger"
          class="w-100"
          size="md"
        >
          Скасувати
        </b-button>
      </div>
    </b-overlay>
  </b-modal>
</template>

<script>
export default {
  props: ["user"],
  data() {
    return {
      isLoading: false,
      show: false,
      message: "",
    };
  },
  methods: {
    async sendSms() {
      this.isLoading = true;
      await this.$api
        .get("/sms/send/?phone=" + this.user.phone + "&message=" + this.message)
        .then(() => {
          this.isLoading = false;
          this.show = false;
          this.$toast.success("СМС успішно надіслано");
        })
        .catch((error) => {
          console.log(error);
          this.$toast.error("Щось пішло не так");
          this.isLoading = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped></style>
